import React, { useEffect, useState, useMemo } from "react"
import { get } from "lodash"

import { SettlementTemplate } from "components/templates/top/settlement"
import { APIResponse } from "redux/apis/types"
import {
  calenderApi,
  foreignCalenderApi,
  label,
} from "components/actions/getProfitAnnouncementCalender"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

export const Settlement = () => {
  const month = get(store.getState().calender, "month")
  const loadResistId = useMemo(() => uuid(), [])
  const [calenderData, setCalenderData] = useState<APIResponse.Res | {}>({})
  const [settlementMonth, changeSettlementMonth] = useState(month)
  const [foreignCurrentPage, foreignChangePage] = useState<number>(0)
  const [displayType, changeDisplayType] = useState({
    type: label[0].id,
    title: label[0].title,
  })
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const requestApi = async () => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    setCalenderData([])
    if (displayType.type === get(label, "[1].id")) {
      await foreignCalenderApi({
        setData: setCalenderData,
        page: foreignCurrentPage,
      })
    } else {
      await calenderApi({
        setData: setCalenderData,
      })
    }
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  useEffect(() => {
    requestApi()
  }, [settlementMonth, displayType])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) requestApi()
  }, [isPageLoading])

  return (
    <SettlementTemplate
      calenderData={calenderData}
      settlementMonth={settlementMonth}
      changeSettlementMonth={changeSettlementMonth}
      displayType={displayType}
      changeDisplayType={changeDisplayType}
      foreignCurrentPage={foreignCurrentPage}
      foreignChangePage={foreignChangePage}
    />
  )
}
